import { request } from "utils/legacy_api";

export function update(userToken) {
  return request("/anonymous_tokens", { method: "PATCH", body: { userToken } });
}
